// components/PrimaryButton.js
import React from "react";
import { Link } from "react-router-dom";

export default function PrimaryButton({
  children,
  onClick,
  type = "button",
  className = "",
  icon: Icon,
  iconPosition = "right", // "left" or "right"
  to = null, // optional route path
  disabled = false,
  loading = false,
}) {
  const isDisabled = disabled || loading;
  const classes = `w-full ${isDisabled ? 'bg-red-300 cursor-not-allowed' : 'bg-red-500 hover:bg-red-600'} text-white py-2 rounded-full font-semibold flex items-center justify-center space-x-2 transition-colors ${className}`;

  const content = (
    <>
      {loading ? (
        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
      ) : (
        iconPosition === "left" && Icon && <Icon className="w-4 h-4" />
      )}
      <span>{loading ? "Processing..." : children}</span>
      {!loading && iconPosition === "right" && Icon && <Icon className="w-4 h-4" />}
    </>
  );

  // If `to` is passed, render a Link
  if (to && !isDisabled) {
    return (
      <Link to={to} className={classes}>
        {content}
      </Link>
    );
  }

  // Default to a regular button
  return (
    <button type={type} onClick={!isDisabled ? onClick : undefined} className={classes} disabled={isDisabled}>
      {content}
    </button>
  );
}
